/* @jsx jsx */
import React from 'react';
import {css, jsx} from '@emotion/react';
const contentWrapperCss = css`
  overflow: hidden;
`;
const ContentWrapper = ({children, className, ...props}) => <div className={className} css={contentWrapperCss} {...props}>{children}</div>;
export default ContentWrapper;
